import React from "react";
import CaseHero from "../container/caseHero/CaseHero";
import CaseForm from "../container/caseForm/CaseForm";
import CaseWork from "../container/caseWork/CaseWork";
import { Helmet } from "react-helmet-async";

const CaseStudies = () => {
  return (
    <>
      <Helmet>
        <title>Case-Studies - Radiksez</title>
        <meta
          name="description"
          content="Radiksez case studies on software development, quality assurance, social media management, and AI & ML validation."
        />
        <link rel="canonical" href="https://radiksez.com/case-studies" />
      </Helmet>
      <CaseHero />
      <CaseWork />
      <CaseForm />
    </>
  );
};

export default CaseStudies;
